import * as React from 'react';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

const manufacturerList = (props) => {

	return (
		<DataTable
			value={props.manufacturers}
			paginator={true}
			lazy={true}
			rows={props.rows}
			totalRecords={props.totalRecords}
			onPage={(event) => props.onPageClick(event)}
			first={props.first}
			dataKey='medicineId'
		//loading={props.isLoading}	
		>
			<Column field="name" header="Name"
				body={(rowData, column) =>
					rowData && rowData.manufacturerContent && rowData.manufacturerContent.length ?
						rowData.manufacturerContent
							.filter(x => typeof x.name === 'string' && x.name.length > 0)
							.map(r => r.name)
							.join(' / ')
						: null
				} />
			{/* <Column field="country" header="Country"
				body={(rowData, column) =>
					rowData && rowData.manufacturerContent && rowData.manufacturerContent.length ?
						rowData.manufacturerContent
							.filter(x => typeof x.country === 'string' && x.country.length > 0)
							.map(r => r.country)
							.join(' / ')
						: null
				} />
			<Column field="city" header="city"
				body={(rowData, column) =>
					rowData && rowData.manufacturerContent && rowData.manufacturerContent.length ?
						rowData.manufacturerContent
							.filter(x => typeof x.city === 'string' && x.city.length > 0)
							.map(r => r.city)
							.join(' / ')
						: null
				} /> */}
			<Column field="address" header="Full Address"
				body={(rowData, column) =>
					rowData && rowData.manufacturerContent && rowData.manufacturerContent.length ?
						rowData.manufacturerContent
							.filter(x => typeof x.address === 'string' && x.address.length > 0)
							.map(r => r.address)
							.join(' / ')
						: null
				} />
			<Column field="phone" header="Phone" />
			<Column
				header="Actions"
				style={{ textAlign: "center", width: "8em" }}
				body={(rowData, column) =>
					<div>
						<Button
							type="button"
							icon="pi pi-pencil"
							className="p-button-warning"
							tooltip="Edit"
							tooltipOptions={{ position: 'top' }}
							style={{ marginRight: ".5em" }}
							onClick={() => props.editClick(rowData.manufacturerId)}
						/>
						<Button
							type="button"
							icon="pi pi-trash"
							className="p-button-danger"
							tooltip="Delete"
							tooltipOptions={{ position: 'top' }}
							onClick={() => props.deleteClick(rowData.manufacturerId)}
						/>
					</div>
				}
			/>
		</DataTable>
	)
}

export default manufacturerList;
